module.exports = __webpack_public_path__ + "img/promo_garrafa_square.9858ad9.webp";